<template>
    <div>
        <div v-show="!noPrice" style="text-align: center">
            <div class="c-babyplant-seleccion">
                <div class="c-bs-visible" :class="{checked: filterElements.babyplantSeleccion}">
                <span class="c-checkbox-group" :class="{checked: filterElements.babyplantSeleccion}"
                      @click="filterElements.babyplantSeleccion = !filterElements.babyplantSeleccion">
                    <span class="checkbox"></span>
                    <img src="/img/iconos/icon_bp_seleccion_custom.svg" alt="icon_bp_seleccion_custom.svg" class="icon">
                    Babyplant Selección
                </span>
                    <img v-b-modal.modal-bpseleccion src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                    <modal-block v-cloak title="Babyplant Selección" :href="route('help.details','babyplant-seleccion')" desing="ecologico" refer="bpseleccion">
                        En Babyplant filtramos y seleccionamos las mejores variedades hortícolas para que obtengas los mejores
                        resultados en tu cosecha. Por eso verás lo que te proponemos como SELECCIÓN con el siguiente
                        icono Babyplant selección
                    </modal-block>
                </div>
                <div v-show="filterElements.babyplantSeleccion" class="zonas">
                    <p class="c-p c-p-zonas">
                        Para poder indicarte la planta más adecuada a tu zona de cultivo,
                        indícanos el tipo de zona o introduce la localidad donde realizarás el
                        cultivo para proponerte las variedades que mejor se adaptan al clima de
                        tu zona.
                    </p>
                    <h4 class="c-question">
                        Indícanos la fecha y el clima de tu zona de cultivo
                    </h4>
                    <bp-seleccion-date v-model="babyplantSeleccionDate" :block-to="blockToDate"></bp-seleccion-date>
                    <div class="search mb-2 mt-3">
                        <div class="d-flex align-items-center">
                            <form class="searchForm">
                                <div class="searchInputContainer">
                                    <input v-model="provincia" placeholder="Introduce código postal o localidad" type="text" class="searchInput" @focus="showMenuProvincias=true" @blur="showMenuProvincias=false">
                                    <i class="fas fa-times cursor_pointer" @click="provincia = ''" style="position: relative" v-show="provincia"></i>
                                </div>
                            </form>
                            <img v-b-modal.modal-provincias src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info" style="right: 0">
                        </div>
                        <modal-block v-cloak title="Introduce tu localidad" :href="route('help.details','zona-fria-zona-calida')" desing="default" refer="provincias">
                            Introduce tu población o CP y te mostraremos las variedades que mejor se adaptan a tu clima.
                        </modal-block>
                        <div v-cloak class="provinciasMenuBlock" v-if="provinciasRecomendadas.length>0&&showMenuProvincias">
                            <div @mousedown="setProvincia(provincia)" v-for="provincia in provinciasRecomendadas">
                                <span>{{ provincia.Poblacion+', '+provincia.Provincia+'('+provincia.CP+')' }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="c-buttons zonas">
                        <a class="item_link item_link_zona_calida" :class="{active: filterElements.zonaCalida }">
                            <span @click="filterElements.zonaCalida = !filterElements.zonaCalida" class="alt_calido no-upper">
                                <img :src="'/img/iconos/' + (filterElements.zonaCalida ? 'icon_calida_active.svg' : 'icon_calida.svg')" alt="icon_calida.svg" class="icon">
                                Zona cálida
                            </span>
                            <img v-b-modal.modal-zonacalida src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                            <modal-block v-cloak title="Zona cálida" :href="route('help.details','zona-fria-zona-calida')" desing="zonacalida" refer="zonacalida">
                                Te mostramos una selección de las variedades que mejor se adaptan a zonas de cultivo cálidas.
                            </modal-block>
                        </a>
                        <a class="item_link item_link_zona_fria" :class="{active: filterElements.zonaFria }">
                        <span @click="filterElements.zonaFria = !filterElements.zonaFria" class="alt_calido no-upper">
                            <img :src="'/img/iconos/' + (filterElements.zonaFria ? 'icon_fria_active.svg' : 'icon_fria.svg')" alt="icon_fria.svg" class="icon">
                            Zona fría
                        </span>
                            <img v-b-modal.modal-zonafria src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                            <modal-block v-cloak title="Zona fría" :href="route('help.details','zona-fria-zona-calida')" desing="zonafria" refer="zonafria">
                                Te mostramos una selección de las variedades que mejor se adaptan a zonas de cultivo frías.
                            </modal-block>
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="showMinOrder" class="show-min-order-checkbox-wrapper">
                <span class="c-checkbox-group only-no-min-order" :class="{checked: filterElements.onlyNoMinOrder}"
                      @click="filterElements.onlyNoMinOrder = !filterElements.onlyNoMinOrder">
                    <span class="checkbox"></span>
                    Mostrar variedades sin pedido mínimo
                </span>
                <p class="m-0" style="color: #c2282d; font-style: italic; font-weight: bold">
                    En rojo el número mínimo de semillas para cada variedad
                </p>
            </div>
            <div v-if="showWithPriceAux">
                <span class="c-checkbox-group only-with-price" :class="{checked: filterElements.onlyWithPrice}"
                      @click="filterElements.onlyWithPrice = !filterElements.onlyWithPrice">
                    <span class="checkbox"></span>
                    Mostrar variedades con precio disponible
                </span>
            </div>
            <div class="container_filter">
                <especie-filter v-model="filterElements.especie"></especie-filter>
                <tipo-filter v-model="filterElements.mote" :especie-id="filterElements.especie"></tipo-filter>
            </div>
            <variety-select-list v-model="valueAux" :filter-elements="filterElements"
                                 @variety-data-changed="varietyDataChanged" :show-min-order="showMinOrder"
                                 :search-filter.sync="searchFilter" ref="varietySelectList"
            ></variety-select-list>
            <variety-select-form></variety-select-form>
            <change-date-variety v-if="dateProblem" :date="minDateDelivery" @other-date="$emit('other-date', $event)"
                                 @date-selected="dateSelected"
            ></change-date-variety>
            <changed-date-variety v-if="dateChanged" :date="dateChanged"
                                  @close="$emit('update:dateChanged', null)"
            ></changed-date-variety>
        </div>
        <no-price v-show="noPrice" @choose-other-variety="noPrice = false"></no-price>
    </div>
</template>

<script>
    import VarietySelectList from "./VarietySelectList";
    import EspecieFilter from "./EspecieFilter";
    import TipoFilter from "./TipoFilter";
    import VarietySelectForm from "./VarietySelectForm";
    import ChangeDateVariety from "./ChangeDateVariety";
    import ChangedDateVariety from "./ChangedDateVariety";
    import NoPrice from "./NoPrice";
    import BpSeleccionDate from "./BpSeleccionDate";

    export default {
        name: "VarietySelectInput",
        components: {
            BpSeleccionDate,
            NoPrice,
            ChangedDateVariety,
            ChangeDateVariety, VarietySelectForm, TipoFilter, EspecieFilter, VarietySelectList},
        props: {
            value: {},
            budgetLineDate: {
                type: Date
            },
            dateChanged: {
                type: Date
            },
            blockToDate: {
                type: Date
            },
            date: {},
            showMinOrder: {
                type: Boolean,
                default: false
            },
            showWithPrice: {
                type: Boolean,
                default: false
            },
            injertable: {
                type: Boolean,
                default: false
            },
            filters: {
                type: Object,
                default: null
            },
            noPriceMessage: {
                type: Boolean,
                default: false
            },
            varietyDataProp: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                provincia: "",
                provinciasRecomendadas: [],
                babyplantSeleccionDate: null,
                showMenuProvincias: false,
                filterElements: {
                    babyplantSeleccion: false,
                    onlyNoMinOrder: false,
                    onlyWithPrice: false,
                    zonaFria: false,
                    zonaCalida: false,
                    especie: null,
                    mote: null,
                    injertable: this.injertable
                },
                showWithPriceAux: false,
                searchFilter: null,
                varietyData: null,
                noPrice: false,
                valueAux: null
            }
        },
        computed: {
            diasPreparacion() {
                let dias = 0;
                if (this.varietyData) {
                    dias = this.varietyData.dias_preparacion;
                }
                return dias;
            },
            blockDateByVariety() {
                let numDaysBeforeDelivery = window.custom.params.num_days_before_delivery;
                let date = moment().startOf('day').add(numDaysBeforeDelivery, 'days');
                if (this.varietyData) {
                    date = date.add(this.diasPreparacion, 'days');
                }
                return date.toDate();
            },
            minDateDelivery() {
                let weekDayForce = window.custom.params.week_day_delivery;
                let date = moment(this.blockDateByVariety);
                if (date.isoWeekday() >= weekDayForce) {
                    date = date.add(1, 'week');
                }
                date = date.isoWeekday(weekDayForce);
                return date.toDate();
            },
            dateProblem() {
                return this.budgetLineDate < this.minDateDelivery;
            },
            filtersSync() {
                let filters = {};
                filters.bp_seleccion = this.filterElements.babyplantSeleccion ? 1 : 0;
                filters.buscar = this.searchFilter;
                filters.especie_id = this.filterElements.especie;
                filters.mote_id = this.filterElements.mote;
                filters.zona_calida = this.filterElements.zonaCalida;
                filters.zona_fria = this.filterElements.zonaFria;
                return filters;
            }
        },
        watch: {
            provincia: function() {
                if(this.provincia.length>=3){
                    this.autocompleteProvincia();
                }else{
                    this.provinciasRecomendadas=[];
                }
            },
            'filterElements.babyplantSeleccion': function () {
                if (!this.filterElements.babyplantSeleccion) {
                    this.babyplantSeleccionDate = null;
                    this.filterElements.zonaCalida = null;
                    this.filterElements.zonaFria = null;
                    this.provincia = "";
                }
            },
            injertable(newVal) {
                this.filterElements.injertable = newVal;
            },
            dateProblem(value) {
                this.$emit('date-problem', value);
            },
            blockDateByVariety(value) {
                this.$emit('date-block-changed', value);
            },
            filters: {
                deep: true,
                handler(newVal, oldVal) {
                    this.setUpFilters();
                }
            },
            filtersSync: {
                deep: true,
                handler(newVal, oldVal) {
                    let filters = Object.assign(Object.assign({}, this.filters), newVal);
                    this.$emit('update:filters', filters);
                }
            },
            noPriceMessage(val) {
                this.noPrice = val;
            },
            noPrice(val, oldVal) {
                this.$emit('update:noPriceMessage', val);
                if (oldVal && !val) {
                    this.$refs.varietySelectList.firstLoad();
                    this.valueAux = null;
                    this.varietyData = null;
                    this.showWithPriceAux = true;
                }
            },
            valueAux(val) {
                this.$emit('input', val);
            },
            value(val) {
                this.valueAux = val
            },
            varietyDataProp(val) {
                this.varietyData = val;
            },
            varietyData(val) {
                this.$emit('update:varietyDataProp', val);
                if (val) {
                    this.noPrice = !val.seed_price_convencional;
                    this.$store.commit('custom/setVarietySelected', val);
                }
            },
            showWithPrice(val) {
                this.showWithPriceAux = val;
            },
            showWithPriceAux(val) {
                this.$emit('update:showWithPrice', val);
            },
            date(val) {
                this.dateBudgetChanged(val);
            }
        },
        methods: {
            autocompleteProvincia: function () {
                let vm = this;
                axios.post('/autocomplete/provincia/', {
                    filter: this.provincia,
                }).then(response => {
                    vm.provinciasRecomendadas=response.data.provincias;
                }).catch(e => {
                    console.error(e);
                });
            },
            setProvincia: function (provincia) {
                let vm = this;
                axios.post('/provincia-zona/', {
                    estacion: provincia.IDEstacion,
                    date: this.babyplantSeleccionDate
                }).then(response => {
                    let zona = response.data.zona;
                    switch (zona) {
                        case "CÁLIDA":
                            vm.filterElements.zonaCalida = true;
                            vm.filterElements.zonaFria = false;
                            break;
                        case "FRÍA":
                            vm.filterElements.zonaFria = true;
                            vm.filterElements.zonaCalida = false;
                            break;
                        default:
                            vm.filterElements.zonaFria = false;
                            vm.filterElements.zonaCalida = false;
                    }
                    vm.showMenuProvincias = false;
                    vm.provincia = provincia.Poblacion+', '+provincia.Provincia+'('+provincia.CP+')';
                }).catch(e => {
                    console.log(e);
                });
            },
            varietyDataChanged(varietyData) {
                this.$emit('variety-data-changed', varietyData);
                this.varietyData = varietyData;
            },
            dateSelected() {
                this.$emit('date-selected', this.minDateDelivery);
            },
            setUpFilters() {
                let filters = this.filters;
                let filterElements = this.filterElements;
                if (filters) {
                    if (filters.bp_seleccion !== null) {
                        filterElements.babyplantSeleccion = !!filters.bp_seleccion;
                        if (filters.bp_seleccion) {
                            filterElements.zonaCalida = filters.zona_calida;
                            filterElements.zonaFria = filters.zona_fria;
                        }
                    }
                    if (filters.especie_id !== null) {
                        filterElements.especie = filters.especie_id;
                        if (filters.mote_id !== null) {
                            filterElements.mote = filters.mote_id;
                        }
                    }
                    if (filters.buscar !== null) {
                        this.searchFilter = filters.buscar;
                    }
                }
                this.filterElements = filterElements;
            },
            dateBudgetChanged(val) {
                if (val) {
                    this.babyplantSeleccionDate = val;
                }
            }
        },
        created() {
            this.setUpFilters();
            this.noPrice = this.noPriceMessage;
            this.valueAux = this.value;
            this.varietyData = this.varietyDataProp;
            this.showWithPriceAux = this.showWithPrice;
            this.dateBudgetChanged(this.date);
        }
    }
</script>

<style scoped>
    .container_filter {
        display: flex;
        position: relative;
        margin: 0 8px 8px 0;
        justify-content: center;
    }

    .container_filter > div {
        float: left;
        margin-right: 10px;
    }

    .c-babyplant-seleccion .c-bs-visible {
        margin-bottom: 0.75em;
    }

    .c-babyplant-seleccion .c-bs-visible.checked {
        margin-bottom: 0.5em;
    }

    .c-babyplant-seleccion img {
        vertical-align: middle;
        border-style: none;
    }

    .c-babyplant-seleccion img.icon {
        width: 25px;
        position: relative;
        bottom: 2px;
        margin-left: 0.5em;
        margin-right: 0.5em;
    }

    .c-checkbox-group {
        cursor: pointer;
        font-weight: bold;
    }

    .c-babyplant-seleccion span.checkbox,
    .c-checkbox-group span.checkbox {
        padding: 0 8.5px;
        border: 1px solid #333;
        position: relative;
    }

    .c-checkbox-group.only-no-min-order {
        margin-bottom: 0.5em;
        display: block;
        color: #c2282d;
    }

    .c-checkbox-group.only-no-min-order .checkbox {
        margin-right: 1em;
        border-color: #c2282d;
    }

    .c-checkbox-group.only-with-price {
        margin-bottom: 1em;
        display: block;
    }

    .c-checkbox-group.only-with-price .checkbox {
        margin-right: 1em;
    }

    .c-babyplant-seleccion .search {
        max-width: 300px;
        margin: auto;
    }

    .c-babyplant-seleccion .provinciasMenuBlock {
        z-index: 100;
    }

    .c-babyplant-seleccion .c-buttons.zonas {
        margin-top: 1.5em;
        margin-bottom: 1.5em;
    }

    .c-checkbox-group:hover span.checkbox:after,
    .c-checkbox-group.checked span.checkbox:after {
        border-color: #c7cf34;
    }

    .c-babyplant-seleccion .c-question {
        font-weight: bold;
        font-size: 1.3em;
    }

    .c-babyplant-seleccion .search .searchInputContainer {
        width: auto;
    }

    .c-babyplant-seleccion .search .searchForm {
        width: 250px;
    }

    .c-babyplant-seleccion .searchForm .searchInputContainer {
        display: flex;
        align-items: center;
    }

    .c-babyplant-seleccion .searchForm input:placeholder-shown + svg {
        visibility: visible;
    }

    .item_link {
        text-decoration: none;
        line-height: 18px;
        color: #333;
        display: inline-block;
        white-space: nowrap;
    }

    .item_link {
        border: 0.3em solid #fec82f;
        padding: 0.75em;
    }

    .item_link.active {
        background-color: #FDC832;
    }

    .item_link > span {
        font-size: 1.2em;
        cursor: pointer;
        margin: 0;
        font-weight: bold;
    }

    .item_link > span {
        margin-left: 0;
    }

    .item_link i {
        position: relative;
        right: 15px;
        z-index: 5;
    }

    .item_link_zona_calida {
        border-color: #808080;
    }

    .item_link_zona_calida.active {
        border-color: #f29021;
        background-color: #f29021;
        color: #ffffff;
    }

    .item_link_zona_fria {
        border-color: #808080;
    }

    .item_link_zona_fria.active {
        border-color: #0871b8;
        background-color: #0871b8;
        color: #ffffff;
    }

    .show-min-order-checkbox-wrapper {
        padding: 0.75rem 0;
        border: 2px solid #c2282d;
        border-radius: 4px;
        margin-bottom: 1.5rem;
    }

</style>

<style>
    .c-checkbox-group:hover span.checkbox:after,
    .c-checkbox-group.checked span.checkbox:after {
        content: "";
        border-left: 5px solid;
        border-bottom: 5px solid;
        position: absolute;
        padding: 4px 10px;
        transform: rotate(-50deg);
        left: 2px;
        bottom: 8px;
    }

    img.icon_info {
        cursor: pointer;
        width: 25px;
        position: relative;
        bottom: 2px;
        z-index: 5;
    }

</style>
